import Event from '../../core/Event';
import Order from '../../../domain/Order';

export default class OrderSaveDraftSucceed extends Event {
    public static type = 'OrderSaveDraftSucceed';

    constructor(public readonly order: Order) {
        super(OrderSaveDraftSucceed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrderSaveDraftSucceed.ts